import { I18n } from '@/i18n/I18n';
import { operationTypes } from '@/types/operationTypes';
import { Container } from '@/backend/models/containers/container';
import { CUSTOM_FIELD_TYPES } from '@/types/customFieldTypes';
import { ParameterInputType } from '@/types/parameterTypes';
import { getParentType, getRootId, getRootType } from '@/backend/lib/utils';
import { Block } from '@/backend/models/block';
import { BasicButton } from '../buttons/BasicButton';
import { useTreeStore } from '@/frontend/store/TreeStore';

export function AddGraphButton(props: { parent: Container | Block, position: number }) {
  const { parent, position } = props;
  const createOperation = useTreeStore((state) => state.createOperation);

  function onClickCreateOperation(operationType: operationTypes, fieldType?: CUSTOM_FIELD_TYPES, inputType?: ParameterInputType) {
    const request = {
      parentId: parent.id,
      position,
      isScaffold: parent instanceof Container ? parent.isScaffold : false,
      type: operationType,
      fieldType,
      inputType,
      rootId: getRootId(parent),
      rootType: getRootType(parent),
      parentType: getParentType(parent),
    };

    return createOperation(request);
  }

  return (
    <div className='d-flex'>
      <BasicButton
        className='btn btn-sm btn-secondary'
        label={I18n.get('addGraph')}
        onClick={() => void onClickCreateOperation(operationTypes.Grapher, CUSTOM_FIELD_TYPES.File, ParameterInputType.FREE_FORM)}
      />
    </div>
  );
}

